export const paymentMethode = {
    HUTANG: 'BON'
}